import { ColDef } from 'ag-grid-enterprise';
import DateTimeRenderer from './DateTimeRenderer';
import ActionsRenderer from './ActionsRenderer';
import { OracleDowntimeScheduleDisplay } from './types';

// Helper function to extract date portion in PST for filtering
const getPSTDateForFilter = (date: Date | null): Date | null => {
  if (!date) return null;
  const pstDateStr = date.toLocaleDateString('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const [month, day, year] = pstDateStr.split('/');
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

export const getOracleDowntimeColDefs = (
  onEdit?: (schedule: OracleDowntimeScheduleDisplay) => void,
  onDelete?: (schedule: OracleDowntimeScheduleDisplay) => void,
): ColDef[] => [
  {
    headerName: 'Type',
    field: 'type',
    tooltipField: 'type',
    filter: 'agSetColumnFilter',
    filterParams: {
      closeOnApply: true,
    },
    flex: 1,
    minWidth: 220,
  },
  {
    headerName: 'Start Date',
    field: 'startDateTime',
    filter: 'agDateColumnFilter',
    cellRenderer: DateTimeRenderer,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueGetter: (params: any) => {
      // Return the Date object for filtering
      return params.data?.startDateTime;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filterValueGetter: (params: any) => {
      return getPSTDateForFilter(params.data?.startDateTime);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tooltipValueGetter: (params: any) => {
      if (!params.value) return '';
      return params.value instanceof Date ? params.value.toLocaleString() : params.value;
    },
    flex: 2,
    minWidth: 250,
    filterParams: {
      closeOnApply: true,
      suppressAndOrCondition: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDateTime',
    filter: 'agDateColumnFilter',
    cellRenderer: DateTimeRenderer,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueGetter: (params: any) => {
      // Return the Date object for filtering
      return params.data?.endDateTime;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filterValueGetter: (params: any) => {
      return getPSTDateForFilter(params.data?.endDateTime);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tooltipValueGetter: (params: any) => {
      if (!params.value) return 'Ongoing';
      return params.value instanceof Date ? params.value.toLocaleString() : params.value;
    },
    flex: 2,
    minWidth: 250,
    filterParams: {
      closeOnApply: true,
      suppressAndOrCondition: true,
    },
  },
  {
    headerName: '',
    field: 'actions',
    cellRenderer: ActionsRenderer,
    cellRendererParams: {
      onEdit,
      onDelete,
    },
    filter: false,
    sortable: false,
    floatingFilter: false,
    flex: 0.5,
    minWidth: 100,
    maxWidth: 120,
  },
];
